"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SportradarEnforcer = void 0;
const casbin_1 = require("casbin");
class SportradarEnforcer extends casbin_1.Enforcer {
    async addRolesForUser(roles, userId) {
        for (const role of roles) {
            // eslint-disable-next-line no-await-in-loop
            await this.addRoleForUser(userId, role);
        }
    }
}
exports.SportradarEnforcer = SportradarEnforcer;
//# sourceMappingURL=SportradarEnforcer.js.map